import { useEffect } from 'react';
import Swal from 'sweetalert2';

const PWA_KEY = 'pwa_install_dismissed';

function esIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

function estaInstalada() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export default function InstalarPWA() {
  useEffect(() => {
    // --- Chrome / Edge: espera beforeinstallprompt ---
    let deferredPrompt = null;

    const handleBeforeInstall = (e) => {
      e.preventDefault();
      deferredPrompt = e;

      if (estaInstalada()) return;
      if (sessionStorage.getItem(PWA_KEY)) return;

      Swal.fire({
        toast: true,
        position: 'top',
        icon: 'info',
        title: 'Instala PIAPO',
        text: 'Accede más rápido desde tu dispositivo',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Instalar',
        cancelButtonText: 'Ahora no',
        confirmButtonColor: '#C0392B',
        timer: 10000,
        timerProgressBar: true,
      }).then((result) => {
        if (result.isConfirmed && deferredPrompt) {
          deferredPrompt.prompt();
          deferredPrompt = null;
          sessionStorage.setItem(PWA_KEY, 'true');
        }
        if (result.dismiss === Swal.DismissReason.cancel) {
          sessionStorage.setItem(PWA_KEY, 'true');
        }
      });
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    // --- iOS / Safari: muestra instrucciones manuales ---
    if (esIOS() && !estaInstalada() && !sessionStorage.getItem(PWA_KEY)) {
      Swal.fire({
        toast: true,
        position: 'top',
        icon: 'info',
        title: '¿Quieres instalar PIAPO?',
        html: '<small>Toca <b>Compartir</b> ➜ <b>Agregar a pantalla de inicio</b></small>',
        showConfirmButton: false,
        showCloseButton: true,
        timer: 10000,
        timerProgressBar: true,
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.close) {
          sessionStorage.setItem(PWA_KEY, 'true');
        }
      });
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  return null;
}
